export enum InboxKeyParam {
  ReferenceNumber = "ReferenceNumber",
  DomainId = "domainId",
}

export enum ApprovalsFiltersName {
  Draft = "draft",
  InProgress = "in progress",
  Completed = "completed",
  Rejected = "rejected",
  Cancelled = "cancelled",
  Returned = "returned",
  Revised = "revised",
}

export interface ApprovalsFilters {
  [ApprovalsFiltersName.Draft]: boolean;
  [ApprovalsFiltersName.InProgress]: boolean;
  [ApprovalsFiltersName.Completed]: boolean;
  [ApprovalsFiltersName.Rejected]: boolean;
  [ApprovalsFiltersName.Cancelled]: boolean;
  [ApprovalsFiltersName.Returned]: boolean;
}

export const INBOX_INITIAL_FILTERS: Partial<ApprovalsFilters> = {
  [ApprovalsFiltersName.Draft]: false,
  [ApprovalsFiltersName.InProgress]: false,
  [ApprovalsFiltersName.Returned]: false,
};

export const TRACKING_INITIAL_FILTERS: Partial<ApprovalsFilters> = {
  [ApprovalsFiltersName.InProgress]: false,
  [ApprovalsFiltersName.Completed]: false,
  [ApprovalsFiltersName.Rejected]: false,
  [ApprovalsFiltersName.Cancelled]: false,
};
